/**
 * Here were building out an object with each possible task profile's set of keys.
 */

/**Possible keys. These should have corresponding translations*/
const ad_qty_type = 'ad_qty_type'
const desc_art_id = 'desc_art_id' //combined description and art_id
// const initial_image_rai = 'initial_image_rai'
// const inventory_item = 'inventory_item'
const limited_quantity_buy = 'limited_quantity_buy'
// const maintain_image_rai = 'maintain_image_rai'
const order_sales_id = 'order_sales_id'
const placement_section = 'placement_section'
const previous_placement_id = 'previous_placement_id'
const prev_rai_code_id = 'prev_rai_code_id'
const previous_ad_quantity = 'previous_ad_quantity' //? todo?
const product_line = 'product_line'
const quantity_installed = 'quantity_installed'
// const remove_image_rai = 'remove_image_rai'
const space_id = 'space_id'
const special_instructions = 'special_instructions'
const task_status = 'task_status'
const task = 'Task' //??
const value = 'coupon_value'
// const test_indicator = 'test_indicator'
const prev_item_installed = 'prev_item_installed'
const kit = 'kit'
const job_description = 'job_description'
const previous_execution_timestamp_tz = 'previous_execution_timestamp_tz'
/**
 * Obj to determine items to render for instore and cart
 * First level would be task type
 * Next is the product line,
 * followed by array of array of keys to render (first level = template row)
 */
export const instoreCartIndexKeys = {
  //INSTALL
  1: {
    //Shelftalk Banner
    28: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
      // prev_item_installed,
    ],
    //Shelf Take-One
    8: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //SSCM
    6: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      value,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // prev_item_installed,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Shelftalk
    9: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //CART
    1: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      ad_qty_type,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //Floortalk
    16: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //Stanchion Signs
    31: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //SM Coupon Takeone
    35: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //Personalised Solutions
    64: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //Basket Liners
    65: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //Information Pocket
    38: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //AdPad Coupon
    36: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //AdPad Information
    37: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //SM Shelf Advertising
    34: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
    //SECURITY PEDESTALS
    66: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      // prev_item_installed,
      // remove_image_rai,
    ],
  },
  //HOLDOVER (premium)
  2: {
    //Shelftalk Banner
    28: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Shelf Take-One
    8: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SSCM
    6: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      value,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      prev_item_installed,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Shelftalk
    9: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //CART
    1: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      ad_qty_type,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      quantity_installed,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      prev_item_installed,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Floortalk
    16: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Stanchion Signs
    31: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SM Coupon Takeone
    35: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Personalised Solutions
    64: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Basket Liners
    65: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Information Pocket
    38: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //AdPad Coupon
    36: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //AdPad Information
    37: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SM Shelf Advertising
    34: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SECURITY PEDESTALS
    66: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
  },
  //HOLDOVER (standard)
  3: {
    //Shelftalk Banner
    28: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Shelf Take-One
    8: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SSCM
    6: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      value,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      prev_item_installed,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Shelftalk
    9: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //CART
    1: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      ad_qty_type,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      quantity_installed,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      prev_item_installed,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Floortalk
    16: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Stanchion Signs
    31: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SM Coupon Takeone
    35: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Personalised Solutions
    64: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Basket Liners
    65: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Information Pocket
    38: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //AdPad Coupon
    36: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //AdPad Information
    37: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SM Shelf Advertising
    34: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SECURITY PEDESTALS
    66: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
  },
  //MAINTENANCE
  4: {
    //Shelftalk Banner
    28: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Shelf Take-One
    8: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SSCM
    6: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      value,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      prev_item_installed,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Shelftalk
    9: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //CART
    1: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      ad_qty_type,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      quantity_installed,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      prev_item_installed,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Floortalk
    16: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Stanchion Signs
    31: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SM Coupon Takeone
    35: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Personalised Solutions
    64: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Basket Liners
    65: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //Information Pocket
    38: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //AdPad Coupon
    36: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //AdPad Information
    37: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SM Shelf Advertising
    34: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
    //SECURITY PEDESTALS
    66: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      special_instructions,
      previous_execution_timestamp_tz,
      // maintain_image_rai,
      // initial_image_rai,
      prev_item_installed,
      // remove_image_rai,
    ],
  },
  //REMOVE
  5: {
    //Shelftalk Banner
    28: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Shelf Take-One
    8: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //SSCM
    6: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      value,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      prev_item_installed,
      special_instructions,
      previous_execution_timestamp_tz,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Shelftalk
    9: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //CART
    1: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      ad_qty_type,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      quantity_installed,
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Floortalk
    16: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Stanchion Signs
    31: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //SM Coupon Takeone
    35: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,
      limited_quantity_buy,
      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Personalised Solutions
    64: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Basket Liners
    65: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //Information Pocket
    38: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //AdPad Coupon
    36: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //AdPad Information
    37: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //SM Shelf Advertising
    34: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
    //SECURITY PEDESTALS
    66: [
      placement_section,
      task,
      product_line,
      desc_art_id,
      order_sales_id,
      task_status,
      // test_indicator,
      space_id,

      previous_placement_id,
      prev_rai_code_id,
      previous_ad_quantity,
      // 'Adapter',
      special_instructions,
      previous_execution_timestamp_tz,
      prev_item_installed,
      // 'Placement Instructions',
      // maintain_image_rai,
      // initial_image_rai,
      // remove_image_rai,
    ],
  },
}

export const merchIndexKeys = [
  placement_section,
  // 'task_id',
  // 'task_type',
  // 'work_type',
  product_line,
  desc_art_id,
  kit, //kit info
  order_sales_id,
  task_status,
  space_id,
  job_description, //Derived from the “Description” attribute on the Order Master
  previous_execution_timestamp_tz,
]

/**
 * Obj to determine keys to render on task profiles
 * Top level is the work type
 * second level would be task type
 * third is the product line,
 * followed by array of array of keys to render (first level = template row)
 */
export const taskProfileIndexStructure = {
  //instore
  1: instoreCartIndexKeys,
  //cart
  2: instoreCartIndexKeys,
}
